import { useEffect, useRef, useState } from "react";

import { syncEngine } from "../lib/sync/syncEngine";

const readStatus = () => ({ ...syncEngine.getStatus(), pendingEntityIds: syncEngine.getPendingEntityIds() });

export const useSyncStatus = () => {
  const [status, setStatus] = useState(readStatus);
  useEffect(() => syncEngine.subscribe((event) => {
    if (event.type === "status" || event.type === "outbox") {
      setStatus(readStatus());
    }
  }), []);
  return status;
};

export const useSyncChanges = (entityTypes, handler) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  const entityKey = entityTypes.join("|");
  useEffect(() => syncEngine.subscribe((event) => {
    if (event.type !== "changed") {
      return;
    }
    if (entityKey.split("|").some((entityType) => event.entities.has(entityType))) {
      handlerRef.current(event);
    }
  }), [entityKey]);
};

export const useLocalBoardRows = () => {
  const [snapshot, setSnapshot] = useState(() => ({ rows: syncEngine.getBoardRows(), ready: syncEngine.getStatus().ready }));
  const readyRef = useRef(snapshot.ready);
  useEffect(() => syncEngine.subscribe((event) => {
    const ready = syncEngine.getStatus().ready;
    if ((event.type === "changed" && event.entities.has("board")) || (event.type === "status" && ready !== readyRef.current)) {
      readyRef.current = ready;
      setSnapshot({ rows: syncEngine.getBoardRows(), ready });
    }
  }), []);
  return snapshot;
};

export const useSyncPresenceVersion = () => {
  const [version, setVersion] = useState(0);
  useEffect(() => syncEngine.subscribe((event) => {
    if (event.type === "presence") {
      setVersion((current) => current + 1);
    }
  }), []);
  return version;
};

export const useSyncEditors = (entityType, entityId) => {
  const version = useSyncPresenceVersion();
  const [editors, setEditors] = useState([]);
  useEffect(() => {
    setEditors(entityType && entityId ? syncEngine.getEditors(entityType, entityId) : []);
  }, [entityType, entityId, version]);
  return editors;
};

export const useSyncOutbox = () => {
  const [outbox, setOutbox] = useState(() => syncEngine.getOutbox());
  useEffect(() => syncEngine.subscribe((event) => {
    if (event.type === "outbox" || event.type === "status") {
      setOutbox(syncEngine.getOutbox());
    }
  }), []);
  return outbox;
};
